export default __webpack_public_path__ + "static/media/testifyEight.495e95c3.png";